import React from 'react';
import { Box, Text, WarningIcon } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

interface ResetPasswordLinkInvalidProps {
  testId: string;
  title: string;
  subTitle: string;
  buttonTitle: string;
  onRequestNewLink: () => void;
}

const ResetPasswordError: React.FC<ResetPasswordLinkInvalidProps> = ({
  testId,
  title,
  subTitle,
  buttonTitle,
  onRequestNewLink 
}) => {
  return (
    <Box
      data-testid={`reset-password_error-screen_${testId}`}
      dir="column"
      align="center"
    >
      <WarningIcon size="48px" />

      <Text
        margin={{ top: 'spacing8' }}
        textAlign="center"
        size="2xl"
        weight={700}
        data-testid="reset-password_error-title"
      >
        {title}
      </Text>

      <Text
        textAlign="center"
        size="large"
        margin={{ top: 'spacing8' }}
        data-testid="reset-password_error-subtitle"
      >
        {subTitle}
      </Text>

      <Box margin={{ top: 'spacing16' }} width="100%">
        <AppButton
          testId="reset-password_request-new-link-btn"
          onClick={onRequestNewLink}
          width="100%"
          size="L"
        >
          {buttonTitle}
        </AppButton>
      </Box>
    </Box>
  );
};

export default ResetPasswordError;
